// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"e6db7e28","209":"79a4644c","508":"3dceb20c","617":"efda2f97","629":"e3e47e7e","851":"fac1d4cd"}[chunkId] + ".chunk.js";
};